module.exports = __webpack_public_path__ + "static/media/Delivering.53a9713b.svg";